export default function setter(months = 0, parent) {
  const years = parent.set_time_year || 0;

  let text = '';

  if (years) {
    text += `${years} ${years > 1 ? 'anos' : 'ano'}`;
  }

  if (years && months) {
    text += ' e ';
  }

  if (months) {
    text += `${months} ${months > 1 ? 'meses' : 'mês'}`;
  }

  return text;
}
